import * as THREE from "three";

/** A treasure chest with a hinged lid. Opens once, stays open. */
export class ChestModel {
  readonly object3D = new THREE.Group();
  private readonly lid = new THREE.Group();
  private targetAngle = 0;
  opened = false;

  constructor(wood = 0x8a5a2b, metal = 0xffd23f) {
    const woodMat = new THREE.MeshLambertMaterial({ color: wood });
    const metalMat = new THREE.MeshLambertMaterial({ color: metal });

    const base = new THREE.Mesh(new THREE.BoxGeometry(0.6, 0.32, 0.44), woodMat);
    base.position.y = 0.16;
    base.castShadow = true;
    base.receiveShadow = true;

    const band = new THREE.Mesh(new THREE.BoxGeometry(0.62, 0.06, 0.46), metalMat);
    band.position.y = 0.16;

    const lock = new THREE.Mesh(new THREE.BoxGeometry(0.1, 0.12, 0.05), metalMat);
    lock.position.set(0, 0.3, 0.23);

    const lidBox = new THREE.Mesh(new THREE.BoxGeometry(0.6, 0.16, 0.44), woodMat);
    lidBox.position.set(0, 0.08, 0.22);
    lidBox.castShadow = true;
    this.lid.add(lidBox);
    // Hinge at the back edge so the lid swings backwards.
    this.lid.position.set(0, 0.32, -0.22);

    this.object3D.add(base, band, lock, this.lid);
  }

  open(): void {
    if (this.opened) return;
    this.opened = true;
    this.targetAngle = -2.1;
  }

  /** Restores the open state without animating — for a chest already looted. */
  setOpenImmediate(): void {
    this.opened = true;
    this.targetAngle = -2.1;
    this.lid.rotation.x = -2.1;
  }

  update(dt: number): void {
    const delta = this.targetAngle - this.lid.rotation.x;
    if (Math.abs(delta) > 0.001) this.lid.rotation.x += delta * Math.min(1, dt * 8);
  }

  dispose(): void {
    this.object3D.traverse((obj) => {
      const mesh = obj as Partial<THREE.Mesh>;
      mesh.geometry?.dispose();
      const m = mesh.material;
      if (Array.isArray(m)) m.forEach((x) => x.dispose());
      else m?.dispose();
    });
  }
}
